export default ['updateLoggedIn', 'updateUser', 'updateToken', 'login'].reduce(
  (acc, value) => {
    acc[value] = value
    return acc
  },
  {}
)
